<mat-checkbox
  [disabled]="checkboxDisabled"
  color="primary"
  (change)="selectAll()"
  [checked]="checkboxChecked">
</mat-checkbox>